import { Injectable } from '@angular/core';
import { CurrentApiService, IDept } from 'dbweb-core';
export enum RoleType {
	always = 'always',
	select = 'select'
}
export interface UserRole {
	Name: string;
	Type: RoleType;
}
// â æ¬è¿çä»£ç 
export interface ColumnsWithLetter {
	Letter: string; // é¦å­æ¯
	Columns: string[];
}
// â æ¬è¿çä»£ç 
@Injectable()
export class UserBack {
	constructor(private api: CurrentApiService) {}
	fetchFilterDept(val: string) {
		return this.api.get<IDept[]>('fetch-filter-dept', val);
	}
	fetchRoles() {
		return this.api.get<UserRole[]>('fetch-roles');
	}
}
